<div class="form-field" padding-y>
  @if (icon && !label) {
    <div class="form-field__input-icon">
      <ng-content select="rt-icon" />
    </div>
  }

  @if (label) {
    <div class="form-field__input-label" [class.truncated-label]="hasTruncatedLabel">
      <ng-content select="rt-label" />
      @if (!hideRequiredBadge && isRequired() && !isControlStatus('DISABLED')) {
        <div class="badge-required">
          <span>*</span>
        </div>
      }
      <ng-content select="rt-icon-help" />
    </div>
  }

  <div class="form-field__input-wrapper">
    <ng-content />
  </div>

  <div class="form-field__input-button">
    <ng-content select="rt-button, rt-icon-button" />
  </div>

  <div class="form-field__input-spinner">
    <ng-content select="rt-spinner" />
  </div>

  @if (hints.length > 0 && !errors.length) {
    <div class="form-field__hint-wrapper">
      @for (hint of hints; track trackByError($index, hint)) {
        <span class="hint">{{ hint }}</span>
      }
    </div>
  } @else if (errors.length > 0 && !isValidationForced) {
    <div class="form-field__error-output">
      @for (error of errors; track trackByError($index, error)) {
        <span class="error">{{ error }}</span>
      }
    </div>
  } @else if (charactersLimit && isFocused) {
    <div class="form-field__characters-counter">
      {{ charactersCount() }} / {{ charactersLimit }}
    </div>
  }
</div>
